import React from 'react';
import { Bell, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function Navbar() {
  const navigate = useNavigate();
  const handleProfileClick = () => {
    navigate('/profile/settings');
  };
  return <nav className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] bg-black py-2" data-id="element-1832">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-1833">
        <div className="flex justify-between items-center" data-id="element-1834">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-1835">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1JuVByZ98RTQ1Zt83kwhSA/The_Social_Hub_idqwy7vsH3_1.svg" alt="The Social Hub" className="h-16 brightness-0 invert" data-id="element-1836" />
          </Link>
          {/* Right side icons */}
          <div className="flex items-center gap-2" data-id="element-1837">
            <button className="p-2 rounded-full hover:bg-gray-800" data-id="element-1838">
              <Bell className="w-5 h-5 text-white" data-id="element-1839" />
            </button>
            <button className="p-2 rounded-full hover:bg-gray-800" onClick={handleProfileClick} aria-label="Manage profile" data-id="element-1840">
              <User className="w-5 h-5 text-white" data-id="element-1841" />
            </button>
          </div>
        </div>
      </div>
    </nav>;
}